<template>
    <div class="count-preview-page">
        <!-- 页面标题 -->
        <!-- <div class="page-title">项目状态统计</div> -->
        <!-- 统计卡片列表 -->
        <!-- <div class="count-card-wrap">
            <div class="count-card" v-for="(item, index) in countList" :key="index" :class="{ active: item.value > 0, last: index === countList.length - 1 }" @click="GoPage(item.id)">
                <div class="status-name">{{ item.name }}</div>
                <div class="status-value">{{ item.value }}</div>
                <!-- 箭头容器 
                <!-- <div class="arrow-icon"></div> 
            </div>
        </div> -->
        <!-- <div class="count-card-wrap">
            <div class="count-card">
                <div class="status-name">申请须知</div>
                <div class="status-value"></div>
            </div>
            <div class="count-card">
                <div class="status-name">下载模板</div>
                <div class="status-value"></div>
            </div>
            <div class="count-card">
                <div class="status-name">去申请</div>
                <div class="status-value"></div>
            </div>
        </div> -->
        <div class="PosRel">
            <div class="Tit">申请须知</div>
            <div class="Cont">内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容</div>
            <div class="ModelDown">
                <div>模板下载： </div>
                <div>
                    <div><a href="###" target="_blank">模板1.exel</a></div>
                    <div><a href="###" target="_blank">模板2.exel</a></div>
                    <div><a href="###" target="_blank">模板3.exel</a></div>
                    <div><a href="###" target="_blank">模板4.exel</a></div>
                    <div><a href="###" target="_blank">模板5.exel</a></div>
                </div>
            </div>
            <div class="PosAbs">
                <div class="PosBtn">去申报</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CountPreview',
        data() {
            return {
                countList: [] ,// 渲染用的统计列表
                SysData:"",
                SysType:"",
            }
        },
        created() {
            // 初始化赋值 - 真实项目中这里替换为接口请求即可
            this.SysData = JSON.parse(sessionStorage.getItem("SYSTEM-Data"));
            this.SysType = this.SysData.id.toString();
            this.getCountData();
        },
        methods: {
            // 获取统计数据方法
            getCountData() {
                this.$get('/api/record/count',{
                    system_sub_id:this.SysType,
                }).then(res => {
                    if (res) {
                        this.countList = res.data.data;
                    }
                })
            },
            GoPage(t){
              // this.$router.push('/ModelPro?type='+t);  
            },
        }
    }
</script>

<style scoped>
    .PosRel{
        width: 1000px;
        margin: 0 auto;
        margin-top: 10px;
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 10px;
    }
    .Tit{
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .Cont{
        height: 40vh;
        overflow-y: auto;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 20px;
        max-height: 600px;
    }
    .ModelDown{
        display: flex;
        align-items: top;
        
    }
    .PosAbs{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }
    .PosBtn{
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #409eff;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
    }
    .PosBtn:hover{
        background-color: #337ecc;
    }
    /* 页面整体样式 */
    .count-preview-page {
        box-sizing: border-box;
    }

    /* 标题样式 */
    .page-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 24px;
        padding-left: 8px;
        border-left: 4px solid #409eff;
    }

    /* 卡片容器 - 流式布局 */
    .count-card-wrap {
        display: flex;
        flex-wrap: wrap;
        flex-wrap: wrap;
        gap: 32px; /* 增大间距，给箭头留出空间 */
        justify-content: flex-start;
        align-items: center;
    }

    /* 统计卡片样式 - 核心样式 */
    .count-card {
        width: 140px;
        height: 120px;
        background: #f9fafc;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        transition: all 0.3s ease;
        border: 1px solid #ebeef5;
        position: relative; /* 为箭头定位做准备 */
        /* margin-right: 20px; */
    }

    /* 鼠标悬浮卡片效果 */
    .count-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    /* 有数值(>0)的卡片高亮样式 - 重点 */
    .count-card.active {
        background: #e6f2ff;
        border-color: #409eff;
    }

    /* 最后一个卡片样式 */
    .count-card.last {
        padding-right: 0; /* 最后一个卡片取消右侧内边距 */
    }

    /* 状态名称 */
    .status-name {
        font-size: 15px;
        color: #606266;
        margin-bottom: 12px;
    }

    /* 状态数值 - 放大突出 */
    .status-value {
        font-size: 28px;
        font-weight: bold;
        color: #333;
    }

    /* 高亮卡片的数值颜色 */
    .count-card.active .status-value {
        color: #409eff;
    }

    .count-card.active .status-name {
        color: #337ecc;
    }

    /* 箭头样式 */
    .arrow-icon {
        position: absolute;
        right: -30px; /* 定位到卡片右侧中间 */
        top: 50%;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
        border-top: 2px solid #dcdfe6;
        border-right: 2px solid #dcdfe6;
        transform: translateY(-50%) rotate(45deg);
        transition: all 0.3s ease;
    }

    /* 高亮卡片的箭头颜色 */
    .count-card.active .arrow-icon {
        border-top-color: #409eff;
        border-right-color: #409eff;
    }

    /* 最后一个卡片隐藏箭头 */
    .count-card.last .arrow-icon {
        display: none;
    }

    /* 鼠标悬浮卡片时箭头的效果 */
    .count-card:hover .arrow-icon {
        opacity: 0.8;
        transform: translateY(-50%) rotate(45deg) scale(1.1);
    }
</style>